import script from "./VUserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VUserCard.vue?vue&type=script&setup=true&lang=ts"

import "./VUserCard.vue?vue&type=style&index=0&id=677b1a43&lang=scss"

const __exports__ = script;

export default __exports__